import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useFragmentVideoEditionQuickCreate } from './useFragmentVideoEditionQuickCreate';

export interface CreateVideoEditionProjectButtonProps {
  /** Fragment the new project will be linked to. */
  fragmentId: string;
  /** Number of existing projects; used to build the auto-generated name index (n = count + 1). */
  currentProjectCount: number;
}

/**
 * Starts quick-create for a video edition project (localized auto name) and redirects to the editor on success.
 */
export function CreateVideoEditionProjectButton({
  fragmentId,
  currentProjectCount,
}: CreateVideoEditionProjectButtonProps) {
  const { createWithAutoName, isCreating } = useFragmentVideoEditionQuickCreate(fragmentId);

  return (
    <Button
      startIcon={<AddIcon />}
      onClick={() => createWithAutoName(currentProjectCount)}
      size="small"
      loading={isCreating}
      disabled={isCreating}
    >
      <FormattedMessage
        id="fragments.videoEditions.createProject"
        defaultMessage="Crear proyecto"
      />
    </Button>
  );
}
